import React, { useState } from "react";
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Typography,
  useTheme,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import SearchIcon from "@material-ui/icons/Search";
import { connect } from "react-redux";
import { actions } from "../redux/actions/alert";
import NumberFormat from "react-number-format";
import styles from "../styles/global-styles";
import { AuthService } from "../services/auth.service";
import { ExpenseService } from "../services/expense.service";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import SiteSelect from "../components/shared/selects/SiteSelect";
import TableHeadExpenses from "../components/stateless/headTables/TableHeadExpenses";
import StyleTableRow from "../styles/styleTableRow";
import StyledTableCell from "../styles/tableCell";
import { changeRowsPerPage } from "../_utils/utils";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
  header: styles.header,
  table: {
    width: 900,
    minWidth: 700,
  },
}));

const ContainerExpense = ({ addAlert, detailAlert }) => {
  const { siteId } = AuthService.currentUserValue;
  const classes = useStyles();
  const theme = useTheme();

  const [startDate, setStartDate] = React.useState(
    moment().subtract(1, "days").startOf("day").format()
  );
  const [endDate, setEndDate] = React.useState(moment().endOf("day").format());
  const [queryParams, setqueryParams] = useState({});
  const [expensesArray, setExpensesArray] = useState([]);
  const [totalExpenses, setTotalExpenses] = useState(null);
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleStartChange = (date) =>
    setStartDate(moment(date).startOf("day").format());

  const handleEndChange = (date) =>
    setEndDate(moment(date).endOf("day").format());

  const handleQuerySelected = (key, value) => {
    setqueryParams({ ...queryParams, [key]: value === "none" ? "" : value });
  };

  // const handleChangePage = (event, newPage) => setPage(newPage);

  const searchExpenseByFilters = async () => {
    console.log("queryParams", queryParams);
    if (moment(endDate).isAfter(moment(startDate))) {
      try {
        const body = {
          ...queryParams,
          startDate,
          endDate,
        };
        console.log("body", body);
        const { data } = await ExpenseService.getAllExpenseWithParams(body);
        console.log("data from expense", data);
        if (data.length) {
          setTotalExpenses(
            data.reduce((acc, item) => acc + parseInt(item.amount), 0)
          );
          setExpensesArray(data);
        } else {
          const error = {
            noData:
              "No se encontraron ninigún resultado, cambiar filtros de búsqueda",
          };
          throw error;
        }
      } catch (error) {
        console.log("error", error);
        addAlert({ showAlert: true });
        detailAlert({
          severity: error.noData ? "warning" : "error",
          message: error.noData
            ? error.noData
            : error.msgs || "Error al recuperar gastos",
        });
      }
    } else {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: "La fecha de inicio es MAYOR a la fecha de fin",
      });
      return;
    }
  };

  return (
    <>
      <Typography variant="h4" component="h4" className={classes.title}>
        Gastos
      </Typography>
      <Grid container direction="row" justify="space-between">
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <Grid item>
            <DatePicker
              disableToolbar
              variant="inline"
              format="DD/MM/yyyy"
              margin="normal"
              autoOk
              disableFuture
              label="Fecha de inicio"
              placeholder="20/02/2021"
              value={startDate}
              onChange={handleStartChange}
            />
          </Grid>
          <Grid item>
            <DatePicker
              disableToolbar
              variant="inline"
              format="DD/MM/yyyy"
              margin="normal"
              autoOk
              placeholder="21/02/2021"
              disableFuture
              label="Fecha de fin"
              value={endDate}
              onChange={handleEndChange}
            />
          </Grid>
        </MuiPickersUtilsProvider>
        <Grid item>
          <SiteSelect site={handleQuerySelected} removeStore />
        </Grid>
        <Grid item>
          <Button
            className={classes.rightButton}
            variant="contained"
            disabled={!Object.keys(queryParams).length}
            onClick={searchExpenseByFilters}
            color="primary"
            endIcon={<SearchIcon color="secondary" />}
          >
            Filtrar
          </Button>
        </Grid>
      </Grid>

      {totalExpenses && (
        <Typography variant="h6" component="h6" style={{ marginTop: 40 }}>
          Total {"   "}
          <NumberFormat
            value={totalExpenses}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
          />
        </Typography>
      )}

      <Grid style={{ marginTop: 15 }}>
        <TableContainer>
          {expensesArray.length > 0 ? (
            <Table className={classes.table} aria-label="customized table">
              <TableHeadExpenses />
              <TableBody>
                {expensesArray
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, i) => (
                    <StyleTableRow key={i} className={classes.row}>
                      <StyledTableCell
                        align="center"
                        style={{ fontWeight: 700 }}
                      >
                        {item.concept}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <NumberFormat
                          value={item.amount}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </StyledTableCell>
                    </StyleTableRow>
                  ))}
              </TableBody>
            </Table>
          ) : (
            <Typography
              variant="h6"
              component="h4"
              style={{ marginTop: 50 }}
              className={classes.header}
            >
              Seleccionar las opciones de busqueda para obtener los gastos por
              sucursal
            </Typography>
          )}
        </TableContainer>
        {/*expensesArray.length > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={expensesArray.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={(event) => {
              const { rowsPerPage, page } = changeRowsPerPage(event);
              setRowsPerPage(rowsPerPage);
              setPage(page);
            }}
          />
          ) */}
      </Grid>
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(undefined, dispatch)(ContainerExpense);
